var map = {
	"./confirmed.ogg": "oyUs",
	"./connected.ogg": "G72S",
	"./disconnected.ogg": "Tljk",
	"./unconfirmed.ogg": "2NdU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FVOk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound ^\.\/.*$
// module id = FVOk
// module chunks = 1